export enum SaleStatusForWeb {
	Available = 0,
	Unavailable = 1,
	Inctive = 7,
	NonPublic = 8,
	Unknown = 9
}
